import { useMemo } from 'react'
import { useBoundStore } from '../../../state/bound.store'
import { selectEditItem } from '../../../state/itineraryState/currentItin.slice'
import { useShallow } from 'zustand/react/shallow'
import { AddressLookupSelectedAddress } from '@eventr/common'

export const useEditItem = (sectionID: number, _id?: string) => {
    const item = useMemo(() => {
        return selectEditItem(useBoundStore.getState(), sectionID, _id)
    }, [sectionID, _id])

    return item
}

export const useItinAddress = () => {
    const { address } = useBoundStore(
        useShallow((s) => ({
            address: s.selectedItinerary?.v2?.[0]?.data?.OSMAddress,
        }))
    )
    return address as undefined | AddressLookupSelectedAddress
}
